import rewardMenuGoal from '../assets/reward-menu-goal.png'
import rewardMenuGoal2x from '../assets/reward-menu-goal@2x.png'
import type { RewardMenuIconProps } from './RewardMenuIcon.types'

/**
 * Goal entry icon of the "Motivieren" menu (Figma 3324-43990).
 *
 * See {@link RewardMenuRewardIcon} for why this is a raster asset.
 *
 * @example
 * <RewardMenuGoalIcon className="reward-dropdown__icon" />
 */
export const RewardMenuGoalIcon = ({ size = 28, className }: RewardMenuIconProps) => (
  <img
    src={rewardMenuGoal}
    srcSet={`${rewardMenuGoal} 1x, ${rewardMenuGoal2x} 2x`}
    alt=""
    aria-hidden
    className={className}
    width={size}
    height={size}
  />
)
